import { isUserCustomer } from '../util/user/userUtils';
export class ClaimGroup {
  constructor() {
    let claimGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.claimGroup = claimGroup;
  }
  getOverviewLink(user) {
    const isCustomer = isUserCustomer(user);
    return isCustomer ? `/${user.account_type}/companies/${this.claimGroup.company_id}/master` : `/${user.account_type}/claim_groups/${this.claimGroup.id}/project_overview`;
  }
  static load(claimGroupJsonObject) {
    return new ClaimGroup(claimGroupJsonObject);
  }
}